import { Unit, forward } from 'effector';
import { createGate } from 'effector-react';

export const createMyGate = (funcToCall: Unit<unknown>) => {
  const NewGate: any = createGate<any>();
  forward({ from: NewGate.state, to: funcToCall });
  return NewGate;
};
